/*
  PILOTA90 — touches dynamiques (28/10/2026)
  1. Apparition douce des sections au défilement.
  2. Compteur animé des guides vendus (chiffre réel déjà affiché, simplement animé).
  3. Barre de progression de lecture en haut de page.
  4. Barre d'offre mobile sur l'accueil (« Le 3ᵉ guide offert ») après l'ouverture.
  5. Reflet lumineux sur les boutons d'achat quand ils entrent à l'écran.
  Tout reste lisible sans JavaScript ; le mouvement est coupé si le visiteur l'a demandé.
*/
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const doc = document.documentElement;
  doc.classList.add('p90-js');

  /* ---------- 0. Vitrine 3D : charger toutes les couvertures tout de suite ----------
     Safari ne déclenche pas toujours le chargement différé des images placées en 3D :
     on force le chargement pour qu'aucune couverture ne reste vide. */
  document.querySelectorAll('.bv__img').forEach((img) => {
    img.loading = 'eager';
  });

  /* ---------- 1. Apparition des sections ---------- */
  const sections = [...document.querySelectorAll('main .shopify-section')].slice(1);
  if (!reduce && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('p90-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    sections.forEach((s) => {
      const r = s.getBoundingClientRect();
      if (r.top < window.innerHeight) return; /* déjà visible : on ne cache rien */
      s.classList.add('p90-reveal');
      io.observe(s);
    });
  }

  /* ---------- 2. Compteur des guides vendus ---------- */
  document.querySelectorAll('.p90h .proof, .p90-proof').forEach((el) => {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const m = node.nodeValue.match(/\+\s?(\d{2,5})/);
      if (!m) continue;
      const target = parseInt(m[1], 10);
      const span = document.createElement('span');
      span.className = 'p90-count';
      span.textContent = m[0];
      const after = node.splitText(m.index);
      after.nodeValue = after.nodeValue.slice(m[0].length);
      node.parentNode.insertBefore(span, after);
      if (reduce || !('IntersectionObserver' in window)) break;
      const io = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        const t0 = performance.now(), dur = 1400;
        const step = (t) => {
          const p = Math.min(1, (t - t0) / dur), eased = 1 - Math.pow(1 - p, 3);
          span.textContent = '+' + Math.round(target * eased);
          if (p < 1) requestAnimationFrame(step);
        };
        span.textContent = '+0';
        requestAnimationFrame(step);
      });
      io.observe(span);
      break;
    }
  });

  /* ---------- 3. Barre de progression ---------- */
  const bar = document.createElement('div');
  bar.className = 'p90-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const max = doc.scrollHeight - window.innerHeight;
      bar.style.transform = `scaleX(${max > 0 ? Math.min(1, window.scrollY / max) : 0})`;
      updateOffer();
      ticking = false;
    });
  };

  /* ---------- 4. Barre d'offre mobile (accueil) ---------- */
  const isHome = window.location.pathname === '/' || window.location.pathname === '';
  const cfg = window.P90_OFFER || {};
  let offer = null;
  if (isHome && cfg.text) {
    offer = document.createElement('div');
    offer.className = 'p90-offerbar';
    offer.innerHTML = `<p><span aria-hidden="true">🎁</span> ${cfg.text}</p><a href="${cfg.url || '/collections/all'}">${cfg.cta || 'Voir les guides'}</a>`;
    offer.hidden = true;
    document.body.appendChild(offer);
  }
  const footer = document.querySelector('footer, .footer');
  function updateOffer() {
    if (!offer) return;
    const past = window.scrollY > window.innerHeight * 0.9;
    const nearEnd = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
    const show = past && !nearEnd;
    if (offer.hidden === !show) return;
    offer.hidden = !show;
    document.body.classList.toggle('p90-has-offerbar', show);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();

  /* ---------- 5. Reflet sur les boutons d'achat ---------- */
  if (!reduce && 'IntersectionObserver' in window) {
    const btns = document.querySelectorAll('.product-form__submit, .p90h .go, [class*="ss-"] .btn, [class*="ssp-"] .btn, .p90-lot__btn, .bv__buy');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('p90-shine');
        io.unobserve(e.target);
      });
    }, { threshold: 0.6 });
    btns.forEach((b) => io.observe(b));
  }
})();
